import { hot } from 'react-hot-loader'
import React from 'react'
import { renderRoutes } from 'react-router-config'
import { ThemeProvider } from 'styled-components'
import { theme } from '@ui-library/sl'
import Layout from './layout'

function App({ route, config }) {
  return (
    <>
      <ThemeProvider theme={theme}>
        <Layout>{route && renderRoutes(route.routes, { config })}</Layout>
      </ThemeProvider>
    </>
  )
}

export default hot(module)(App)
